<template>
  <div class="ppv-modal-header">
    <div class="ppv-modal-header-title">
      <h3>{{ title }}</h3>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
    <button class="ppv-modal-header-close" @click="handleClose">
      <v-icon>{{ icons.mdiClose }}</v-icon>
    </button>
  </div>
</template>

<script>
import icons from '@/mixins/icons'

export default {
  name: 'PpvModalHeader',
  mixins: [icons],
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.ppv-modal-header {
  background: #06191e;
  color: #fff;
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.ppv-modal-header-title h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}
.ppv-modal-header-title p {
  margin: 4px 0 0;
  font-size: 13px;
  opacity: 0.7;
}
.ppv-modal-header-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  opacity: 0.8;
  padding: 0;
  line-height: 1;
}
.ppv-modal-header-close:hover {
  opacity: 1;
}
.ppv-modal-header-close .v-icon {
  color: #fff !important;
  font-size: 24px !important;
}
</style>
